import React from 'react';

import IntlMessages from '@src/util/IntlMessages';

import ReportTabsBar from '../ReportTabsBar';
import styles from './styles.module.less';

export type TasksReportTab = 'summary' | 'detail';

const TAB_ITEMS = [
  { key: 'summary', label: <IntlMessages id="dashboards.schedules.tab.summary" /> },
  { key: 'detail', label: <IntlMessages id="dashboards.schedules.tab.detail" /> },
];

interface TasksReportTabsProps {
  activeTab: TasksReportTab;
  onChange: (tab: TasksReportTab) => void;
}

/** Summary / detail switch of the task report. */
const TasksReportTabs: React.FC<TasksReportTabsProps> = ({ activeTab, onChange }) => (
  <ReportTabsBar
    className={styles.tabsWheelRegion}
    bleed
    activeKey={activeTab}
    onChange={key => onChange(key as TasksReportTab)}
    items={TAB_ITEMS}
  />
);

export default TasksReportTabs;
